import { render, staticRenderFns } from "./Subdepartamentos.vue?vue&type=template&id=681eb0ca&"
import script from "./Subdepartamentos.vue?vue&type=script&lang=js&"
export * from "./Subdepartamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports